export default __webpack_public_path__ + "static/media/Nav_BannerPromo.4a725c8f.png";